import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { ApiService } from 'src/app/core/service/api.service';
import { UploadScreenInfo } from 'src/app/shared/components/atoms/file-upload-component/model/file-uplaod.interface';
import { loadFileTaxInformation } from 'src/app/state/actions/upload-file-tax-information.actions';
import { getUploadTaxFile } from 'src/app/state/reducers/upload-file-tax-information.reducer';
import { UploadScreenTaxInfo } from '../model/tax-validation';

@Injectable({
  providedIn: 'root',
})
export class TaxValidationService {
  constructor(private apiSrv: ApiService, private store: Store<any>) {}

  getDuplicated(numIdem: string, street: string | undefined, streetNumber?: number | undefined): Observable<any> {
    const data = {
      numeroIdentificacion: numIdem,
      street: street,
      streetNumber: streetNumber,
    };
    return this.apiSrv.post('api/validate-request-is-duplicate', data, {
      showError: true,
      ngxSpinner: true,
    });
  }

  getUploadFileTaxInfo(): Observable<UploadScreenTaxInfo> {
    let resp: UploadScreenTaxInfo = {
      fileBackCI: undefined,
      fileFrontCI: undefined,
      ciValidationRequired: false,
    };
    this.store.select(getUploadTaxFile).subscribe((data) => {
      console.log('data',JSON.stringify(data));
      resp = data;
    });
    return of(resp);
  }

  saveFilesTaxInfo(upload: UploadScreenTaxInfo) {
    console.log('savefiles', JSON.stringify(upload));
    this.store.dispatch(loadFileTaxInformation({ uploadFileTaxInfo: upload }));
  }
}
